export default __webpack_public_path__ + "static/media/HOO-BUSD.91337fce.svg";